import { graphql } from "react-relay";

export const LOGIN_AS_USER_JWT_MUTATION = graphql`
	mutation impersonateUserButton_loginAsUserJwtMutation($input: LoginAsUserJwtInput!) {
		Admin {
			Auth {
				loginAsUserJwt(input: $input) {
					jwtTokens {
						accessToken
						refreshToken
					}
				}
			}
		}
	}
`;
